import { useEffect, useState } from "react";
import {
  FormSchema,
  FormData as GrafferFormData,
} from "@graffer-inc/form-schema";
import { FileHolder, MyNumberHolder } from "@graffer-inc/cloud-gov-core";
import {
  ReadOnlyFormGeneratorProps,
  ReadonlyFormViewModel,
} from "../../../../application/domain/form-model/readonly-form-view-model";

export const useReadOnlyForm = (args: {
  formSchema: FormSchema;
  initialValues?: GrafferFormData;
  validateOnInit?: boolean;
  initialFileRegistry?: FileHolder;
  initialMyNumberRegistry?: MyNumberHolder;
  formSubmissionContext: ReadOnlyFormGeneratorProps["formSubmissionContext"];
}) => {
  const viewModel = ReadonlyFormViewModel.create({
    ...args,
    initialValues: args.initialValues || {},
  });
  const [state, setState] = useState<ReadOnlyFormGeneratorProps>(
    viewModel.getProps(),
  );

  useEffect(() => {
    viewModel.setOnUpdated((props) => {
      setState(props);
    });
  }, [setState, viewModel]);

  useEffect(() => {
    setState(viewModel.getProps());
  }, [args.initialValues]);

  return {
    ...state,
  };
};
